import roundDown from './roundDown';

/**
 * Generate the default crop values based on the original image dimensions and the aspect ratio of the crop
 *
 * eg: Return a centered square crop from a portrait image:
 * getDefaultCrop(100, 200, 1) => { x: 0, y: 0.25, width: 1, height: 0.5 }
 *
 * @param {number} imageWidth      The width of the original image
 * @param {number} imageHeight     The height of the original image
 * @param {number} cropAspectRatio The aspect ratio of the crop
 *
 * @return {Crop}                   The default crop values
 */
const getDefaultCrop = (imageWidth, imageHeight, cropAspectRatio) => {
  const crop = {
    x: 0,
    y: 0,
    width: 1,
    height: 1,
  };

  const imageAspectRatio = imageWidth / imageHeight;

  if (cropAspectRatio > imageAspectRatio) {
    // If the crop's aspect ratio is greater than the image's aspect ratio, the width of the image is the limiting factor.
    // So, we reduce the height of the crop within the image.
    crop.height = roundDown(imageAspectRatio / cropAspectRatio);
    // Center the crop vertically
    crop.y = roundDown((1 - crop.height) / 2);
  } else {
    // If the crop's aspect ratio is less than the image's aspect ratio, the height of the image is the limiting factor.
    // So, we reduce the width of the crop within the image.
    crop.width = roundDown(cropAspectRatio / imageAspectRatio);
    // Center the crop horizontally
    crop.x = roundDown((1 - crop.width) / 2);
  }

  return crop;
};

export default getDefaultCrop;
